import claims from './modules/claims/store'
import resolutions from './modules/resolutions/store'

export default {
  namespaced: true,
  modules: {
    claims,
    resolutions,
  },
}
